module.exports = __webpack_public_path__ + "img/facture_protegee.d0e12967.png";